module.exports = __webpack_public_path__ + "static/media/bg-3.f167023d.png";